module.exports = __webpack_public_path__ + "files/02a7a101dd178e2d194838b3c1e2070f.png";